(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eagle-2026-campaign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tracks = () => document.querySelectorAll('[data-es-carousel]');
    const syncTrack = (track) => {
      const max = track.scrollWidth - track.clientWidth;
      const offset = Math.abs(track.scrollLeft);
      document.querySelectorAll('[data-es-slide]').forEach((button) => {
        if (button.getAttribute('aria-controls') !== track.id) return;
        button.parentElement.hidden = max < 2;
        button.disabled = button.dataset.esSlide === '-1' ? offset <= 2 : offset >= max - 2;
      });
    };
    const startHeroVideo = (video) => {
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.loop = true;
      video.play().catch(() => {});
    };
    const startHeroVideos = () => document.querySelectorAll('.es-min-hero__video').forEach(startHeroVideo);
    const setup = () => {
      tracks().forEach(syncTrack);
      startHeroVideos();
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const slide = event.target.closest('[data-es-slide]');
      if (slide && !slide.disabled) {
        const track = document.getElementById(slide.getAttribute('aria-controls'));
        if (track) {
          const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: Number(slide.dataset.esSlide) * rtl * track.clientWidth * .85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
    });
    document.addEventListener('scroll', (event) => { if (event.target instanceof Element && event.target.matches('[data-es-carousel]')) syncTrack(event.target); }, true);
    document.addEventListener('canplay', (event) => { if (event.target instanceof HTMLVideoElement && event.target.classList.contains('es-min-hero__video')) startHeroVideo(event.target); }, true);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) startHeroVideos(); });
    window.addEventListener('pageshow', startHeroVideos);
    window.addEventListener('resize', () => tracks().forEach(syncTrack));
    document.addEventListener('shopify:section:load', setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
